import { useQuery } from '@apollo/client';

import { TlscpEntityVariant } from '@/generated/gql/graphql';

import { DEMAND_MASKING_QUERY, NEGOTIATION_CASE_MASKING_QUERY } from './MaskedBiddingQuery.gql';

export const useMaskedBiddingByEntity = (entityId: string, entityVariant: TlscpEntityVariant) => {
  const { data: demandQuery } = useQuery(DEMAND_MASKING_QUERY, {
    variables: {
      id: entityId,
    },
    skip: entityVariant !== TlscpEntityVariant.DEMAND,
  });

  const { data: negotiationCaseQuery } = useQuery(NEGOTIATION_CASE_MASKING_QUERY, {
    variables: {
      id: entityId,
    },
    skip: entityVariant !== TlscpEntityVariant.NEGOTIATION_CASE,
  });

  return {
    isMaskedBidding:
      demandQuery?.tesseract?.demand?.competitiveBiddingRule.isMaskedBidding ||
      negotiationCaseQuery?.tesseract?.negotiationCase?.isMaskedBidding,
  };
};
